import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importaciones de módulos.
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';

// Importaciones de componentes.
import { HostDeleteDialogComponent } from './host-delete-dialog.component';

@NgModule({
  declarations: [HostDeleteDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  exports: [HostDeleteDialogComponent],
})
export class HostDeleteDialogModule {}
